<template>
  <section class="regional-settings">
    <div class="layout miBcycle" :class="{'regional': currTab && currTab.id === '200'}">
      <div class="system-setting">
        <!-- 主tab选择 -->
        <div class="layout-header-tab" style="width: calc(100% - 2.0625rem);z-index:22;">
          <template v-for="item in configJs">
            <span v-if="!item.isHide" @click="tabChange(item)" :key="item.id" :class="{active: item.active || item.id === currTab.relativeId}" class="tab">{{item.name}}</span>
          </template>
        </div>
      </div>
    </div>
    <keep-alive>
      <component v-bind:is="currentTabComponent" :asCom="true"></component>
    </keep-alive>
  </section>
</template>

<script>
// 公用
// import Api from '@/api'
import configJs from './index'
// 组件
import SystemSettings from '../SystemSettings/index'
import noEntryFence from './components/noEntryFence'
import regional from './components/regional'
import siteFence from './components/siteFence'
import thirdPartyAuth from './components/thirdPartyAuth'

export default {
  name: 'regional-settings',
  data() {
    return {
      configJs: JSON.parse(JSON.stringify(configJs))
      // currentTabComponent: 'SystemSettings'
    }
  },
  computed: {
    currTab() {
      return this.configJs.find(item => item.active)
    },
    currentTabComponent: {
      get() {
        return this.currTab.component
      },
      set(val) {}
    }
  },
  methods: {
    tabChange(item) {
      // console.log(item)
      this.configJs.forEach(item => (item.active = false))
      const currTab = this.configJs.find(it => +it.id === +item.id)
      currTab.active = true
      if (item && item.component) {
        this.currentTabComponent = item.component
      } else {
        this.currentTabComponent = undefined
      }
    }
  },
  components: {
    SystemSettings,
    noEntryFence,
    regional,
    siteFence,
    thirdPartyAuth
  }
}
</script>

<style lang="less">
@import "../MiBicycle/miBicycle.less";
</style>
<style lang="less" scoped>
  .regional-settings {
    .layout.regional {
      // margin-left:0px;
      z-index: 11;
    }
  }
</style>
